import { Link } from "react-router-dom";

export default function LocationHero() {
  return (
    <section className="relative w-full overflow-hidden" style={{ height: "70vh", minHeight: "550px" }}>
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://images-pw.pixieset.com/site/BAJyQr/0PjQvm/18-430f468f-1500.jpg"
          alt="Precious Keepsakes Photography serving San Antonio Texas"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/65" />
      </div>
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-8">
        <nav className="flex items-center gap-2 mb-6 text-white/50 font-sans text-xs tracking-widest uppercase">
          <Link to="/" className="hover:text-pk-gold transition-colors cursor-pointer">Home</Link>
          <span>/</span>
          <span className="text-pk-gold">Location</span>
        </nav>
        <div className="flex items-center gap-4 mb-4">
          <div className="w-8 h-px bg-pk-gold" />
          <span className="font-sans text-xs tracking-widest3 uppercase text-pk-gold">San Antonio, Texas</span>
          <div className="w-8 h-px bg-pk-gold" />
        </div>
        <h1 className="font-display text-6xl md:text-8xl font-light text-white leading-tight max-w-4xl">
          Proudly Serving<br /><em className="font-medium">San Antonio</em>
        </h1>
        <p className="font-display text-xl italic text-white/70 mt-5 max-w-xl leading-relaxed">
          Luxury photography serving families across the Alamo City and Texas Hill Country
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center gap-5">
          <Link to="/services" className="bg-pk-gold text-white font-sans text-sm tracking-widest uppercase px-10 py-4 rounded-sm hover:bg-white hover:text-pk-charcoal transition-colors duration-300 whitespace-nowrap cursor-pointer">
            Book a Local Session
          </Link>
          <a href="tel:2108154698" className="font-sans text-sm text-white/70 hover:text-pk-gold transition-colors duration-300 whitespace-nowrap cursor-pointer">
            210-815-4698
          </a>
        </div>
      </div>
    </section>
  );
}